import { Flex, Loader, Text } from '@mantine/core'
import { createFileRoute } from '@tanstack/react-router'
import { useEffect, useMemo } from 'react'
import { fetchOrders } from '@/entities/order/api'
import { orderKeys, useDashboardOrdersQuery } from '@/entities/order/model'
import { useStartOnboardingTutorial } from '@/features/onboarding/lib'
import { filterGroupedOrdersBySearch } from '@/features/search/lib'
import { useSearchStore } from '@/features/search/model'
import { OrdersBoard } from '@/widgets/orders-board'

export const Route = createFileRoute('/_dashboard/dashboard/')({
  component: HelloScreensDashboard,
  loader: ({ context: { queryClient } }) => {
    queryClient.prefetchQuery({
      queryKey: orderKeys.orders(),
      queryFn: fetchOrders,
    })
  },
  pendingComponent: () => (
    <Flex direction="column" align="center" justify="center" style={{ flex: 1, minHeight: 300 }}>
      <Loader size="xl" />
      <Text mt="md">Loading orders...</Text>
    </Flex>
  ),
  errorComponent: error => (
    <Flex direction="column" align="center" justify="center">
      <Text c="red">
        Error:
        {' '}
        {error instanceof Error ? error.message : 'An unexpected error occurred while loading orders.'}
      </Text>
    </Flex>
  ),
})

function HelloScreensDashboard() {
  useStartOnboardingTutorial()
  const { data: orders } = useDashboardOrdersQuery()
  const { searchQuery, clearSearch } = useSearchStore()

  useEffect(() => {
    clearSearch()
  }, [clearSearch])

  const filteredOrders = useMemo(() => {
    return filterGroupedOrdersBySearch(orders, searchQuery)
  }, [orders, searchQuery])

  return (
    <OrdersBoard
      orders={filteredOrders}
    />
  )
}
